<template>
  <div style="padding: 20px">
    <div class="query-form">
      <el-form label-position="right" inline>
        <el-form-item label="店铺">
          <BrandSelect
            :data="vendorList"
            v-model="form.vendorId"
            filterable
            clearable
          ></BrandSelect>
        </el-form-item>
        <el-form-item label="品牌">
          <BrandSelect
            :data="brandList"
            v-model="form.brandIds"
            collapse-tags
            multiple
            filterable
            clearable
          ></BrandSelect>
        </el-form-item>
        <el-form-item label="季节">
          <BrandSelect
            :data="seasonList"
            v-model="form.seasonCodeList"
            collapse-tags
            multiple
            filterable
            clearable
          ></BrandSelect>
        </el-form-item>
        <el-form-item label="类目">
          <el-cascader
            v-model="form.categoryIds"
            :options="categoryList"
            :props="optionProps"
            multiple
            collapse-tags
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item label="有无库存">
          <el-select v-model="form.stockStatus" filterable>
            <el-option
              v-for="item in stockStatusList"
              :label="item.label"
              :value="item.value"
              :key="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click.stop="query">查询</el-button>
          <el-button @click.stop="resetQuery">重置</el-button></el-form-item
        >
        <el-form-item style="padding-left: 30px">
          <el-button
            type="primary"
            style="margin-right: 20px"
            :icon="isLoading ? 'el-icon-loading' : 'el-icon-download'"
            @click="exportTableData()"
            >导出</el-button
          >
          最近导出结果：
          <a
            v-for="item in fileList"
            :key="item"
            @click="downloadExcel(item)"
            class="downloadA"
          >
            {{ item.fileName }}
          </a>
        </el-form-item>
      </el-form>
    </div>

    <el-table
      class="myTable"
      :data="tableData"
      @row-click="handleRowClick"
      row-class-name="cursorPoniter"
      ref="myTable"
    >
      <el-table-column type="expand" width="1">
        <template slot-scope="scope">
          <el-card style="max-width: 600px; margin-left: 60px">
            <el-table :data="scope.row.skuList">
              <el-table-column
                prop="skuId"
                label="Sku_ID"
                min-width="120"
              ></el-table-column>
              <el-table-column
                prop="size"
                label="尺码"
                min-width="120"
              ></el-table-column>
              <el-table-column
                prop="retailPrice"
                label="吊牌价"
                min-width="120"
              ></el-table-column>
              <el-table-column
                prop="supplyPrice"
                label="供货价"
                min-width="120"
              ></el-table-column>
            </el-table>
          </el-card>
        </template>
      </el-table-column>
      <el-table-column
        prop="productId"
        label="Product_ID"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="vendorName"
        label="店铺"
        min-width="120"
      ></el-table-column>
      <el-table-column prop="boutiqueId" label="商品编码" min-width="120">
      </el-table-column>
      <el-table-column prop="designerId" label="货号" min-width="120">
      </el-table-column>
      <el-table-column prop="colorCode" label="颜色" min-width="120">
      </el-table-column>
      <el-table-column prop="brandName" label="品牌" min-width="120">
      </el-table-column>
      <el-table-column
        prop="seasonCode"
        label="季节"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="categoryName"
        label="类目"
        min-width="120"
      ></el-table-column>
    </el-table>
    <el-pagination
      style="text-align: right; margin: 20px 0; padding-bottom: 20px"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="form.pageNo"
      :page-sizes="[15, 25, 30, 50]"
      :page-size="form.pageSize"
      layout="total, prev, pager, next,sizes, jumper"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
import { downloadFile, formatDateTime } from "@/utils/functions";
import {
  getBpDocPageList,
  queryNewVendorList,
  downloadFileUrl,
  getBpSkuList,
  exportBpDocPageList,
  getExportHistory,
} from "../api.js";
import { getBrandList, category, seasonList } from "@/api/merchants_cn";

import BrandSelect from "@/views/components/brandSelect.vue";

export default {
  data() {
    return {
      vendorList: [],
      cities: [],
      activityName: "",
      form: {
        vendorId: "",
        brandIds: [],
        categoryIds: [],
        seasonCodeList: [],
        stockStatus: "",
        pageNo: 1,
        pageSize: 15,
      },
      total: 0,
      tableData: [],
      brandList: [],
      categoryList: [],
      optionProps: {
        expandTrigger: "hover",
        emitPath: false,
        checkStrictly: false,
        multiple: true,
      },
      seasonList: [],
      fileList: [],
      stockStatusList: [
        { label: "无库存", value: 0 },
        { label: "有库存", value: 1 },
      ],
      timer: null,
      exportForm: {},
      isLoading: false,
    };
  },
  components: { BrandSelect },
  created() {},
  mounted() {
    queryNewVendorList({
      supplyPriceMethod: 1,
      includeVendorTypes: [0, 2],
    }).then((res) => {
      this.vendorList = ((res.data && res.data.data) || []).map((item) => {
        return {
          label: item.vendorName,
          value: item.vendorId,
        };
      });
    });
    getBrandList().then((res) => {
      this.brandList = (res.data || []).map((item) => ({
        label: item.englishName,
        value: item.brandId,
      }));
    });
    category().then((res) => {
      if (res && res.data) {
        this.categoryList = Object.freeze(this.gatherCategory(res.data));
      }
    });

    seasonList().then((res) => {
      this.seasonList = (res.data || []).map((item) => ({
        label: item.chineseName,
        value: item.seasonCode,
      }));
    });
    this.getLastTaskList();
    this.timer = setInterval(() => {
      this.getLastTaskList();
    }, 5000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); // 清除定时器以避免内存泄漏
    }
  },
  methods: {
    gatherCategory(items) {
      if (Array.isArray(items)) {
        return items.map((item) => {
          let newItem = {
            label: item.chineseName,
            value: item.categoryId,
          };
          if (Array.isArray(item.children)) {
            newItem.children = this.gatherCategory(item.children);
          }
          return newItem;
        });
      } else {
        return items;
      }
    },
    query() {
      this.form.pageNo = 1;
      this.getTableData();
    },
    resetQuery() {
      this.form = {
        vendorId: "",
        brandIds: [],
        categoryIds: [],
        seasonCodeList: [],
        stockStatus: "",
        pageNo: 1,
        pageSize: 15,
      };
      this.total = 0;
      this.tableData = [];
      // this.getTableData();
    },
    async getTableData() {
      if (!this.form.vendorId) {
        this.$message.error("请选择店铺!");
        return;
      }
      this.$store.commit("setPageLoading", true);
      this.exportForm = { ...this.form };
      let resData = await getBpDocPageList(this.form);
      this.$store.commit("setPageLoading", false);
      if (!resData.data) {
        this.$message.error(`${resData.message}`);
        return;
      }
      let { total, bpDocList } = resData.data;
      this.total = total;
      this.tableData = (bpDocList || []).map((item, index) => {
        return {
          ...item,
          rowId: index,
          isExpand: false,
          skuList: [],
        };
      });
    },
    handleSizeChange(val) {
      this.form.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.form.pageNo = val;
      this.getTableData();
    },
    exportTableData() {
      if (this.isLoading) {
        this.$message.error("正在导出中!");
        return;
      }
      if (!this.tableData.length) {
        this.$message.error("无数据需要导出!");
        return;
      }
      let searchQuery = { ...this.exportForm };
      if (!searchQuery.vendorId) {
        this.$message.error("请选择店铺!");
        return;
      }
      searchQuery.vendorName = (
        this.vendorList.find((item) => item.value == searchQuery.vendorId) || {
          label: "",
        }
      ).label;
      this.$store.commit("setPageLoading", true);
      exportBpDocPageList({
        ...searchQuery,
      }).then((res) => {
        this.$store.commit("setPageLoading", false);
        if (res && res.success) {
          this.$message.success("导出任务已创建");
          this.getLastTaskList();
        } else {
          this.$message.error(res.message || "系统错误，请稍后再试");
        }
      });
    },
    async getLastTaskList() {
      var res = await getExportHistory({ statusList: "0,1,2" });
      if (res.success && res.data) {
        var fileList = [];
        var statusList = [];
        (res.data || []).map((item) => {
          statusList.push(item.status);
          if (item.fileUrl) {
            var vendorName =
              (JSON.parse(item.requestParams) || { vendorName: "" })
                .vendorName || "";
            fileList.push({
              ...item,
              fileUrl: item.fileUrl.replace("http:", "https:"),
              fileName:
                vendorName +
                " " +
                formatDateTime(
                  item.createdAt || new Date(),
                  "yyyy-MM-dd HH:mm:ss"
                ) +
                ".xlsx",
            });
          }
        });
        var oldLoading = this.isLoading;
        if (statusList.includes(0) || statusList.includes(1)) {
          this.isLoading = true;
        } else {
          this.isLoading = false;
          if (oldLoading) {
            this.downloadExcel(fileList[0]);
          }
        }
        this.fileList = fileList;
      }
    },
    downloadExcel(file) {
      try {
        downloadFileUrl(file.fileUrl).then((res) => {
          downloadFile(res.data, file.fileName);
        });
      } catch (error) {
        console.log(error);
      }
    },
    handleRowClick(row, column, event) {
      let { isExpand, rowId } = row;
      if (!isExpand) {
        this.getSkuList(row);
      }
      this.$refs.myTable.toggleRowExpansion(row, !isExpand); // 点击button展开
      this.tableData[rowId].isExpand = !isExpand;
    },
    async getSkuList(row) {
      var res = await getBpSkuList(row.boutiqueProductId);
      if (res.success && res.data) {
        this.tableData[row.rowId].skuList = res.data;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.dialogContainer .el-checkbox {
  margin-left: 0;
  margin-right: 20px;
  margin-bottom: 5px;
}
.manipulate {
  margin-right: 12px;
  color: #409eff;
  cursor: pointer;
}
.dot {
  display: inline-block;
  margin-right: 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.gray {
  background: #cccccc;
}
.green {
  background: green;
}
.dropdown-item {
  margin: 0;
  padding: 7px 16px;
  clear: both;
  color: #657180;
  font-size: 12px !important;
  white-space: nowrap;
  list-style: none;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
}
.demo-ruleForm {
  margin: 20px 0px;
}
.flex {
  height: 80px;
  padding-top: 13px;
  padding-left: 10px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
}
.absolute {
  position: absolute;
  top: 0;
  left: 168px;
}
.cursorPoniter {
  cursor: pointer;
}
.downloadA {
  padding-right: 14px;
  font-weight: bold;
  &:hover {
    color: red !important;
  }
  i {
    padding-right: 4px;
    font-weight: bold;
  }
}
.myTable {
  /deep/.el-table__expand-column {
    .cell {
      display: none;
    }
  }
}
</style>
